export default function (isoString) {
  const options = {
    day: 'numeric',
    month: 'long',
  };
  const locale = 'ru-RU';

  return new Date(isoString).toLocaleDateString(locale, options);
}
